<template>
    <div class="container">
        <div class="row score-page">
            <div class="col s12 m12 l12 xl8">

                <h3 class="title">{{ month }}'s Stress Score</h3>

                <div v-for="(q, index) in questions" v-if="index == current_question_index && !is_preview">
                    <div class="row">
                        <div class="col s12">
                            <h5 class="title">{{ q.name }} <span class="text-highlight">{{ q.value }}</span></h5>
                        </div>
                    </div>
                    <p class="range-field">
                        <label>Please choose your score</label>
                        <input type="range" id="score" min="0" max="20" v-model="q.value"/>
                    </p>
                    <div class="row">
                        <div class="col s12">
                            <p :class="{'active' : q.comment}" :for="'comment_' + index">Comment</p>
                            <textarea required :id="'comment_' + index" placeholder="" style="padding: 10px;width: 100%;height: 200px" v-model="q.comment"></textarea>
                            <span class="helper-text" data-error="wrong" data-success="right">State your reason for this score</span>
                        </div>
                    </div>
                    <div class="row right-align">
                        <div class="col s12">

                            <a @click="decrement_question"
                               v-if="current_question_index > 0">Back</a>&nbsp;&nbsp;

                            <a @click="increment_question"
                               v-if="current_question_index < (questions.length - 1)"
                               :disabled="!q.comment || (q.value == 0)"
                               class="waves-effect waves-light btn">
                                Next
                            </a>

                            <a @click="preview"
                               v-if="current_question_index == (questions.length - 1)"
                               :disabled="!q.comment || (q.value == 0)"
                               class="waves-effect waves-light btn">
                                Preview
                            </a>

                        </div>
                    </div>
                </div>


                <div class="chart-legend" v-if="is_preview">
                    <h4>Summary </h4>

                    <ul class="collapsible popout" ref="score_collapse">
                        <li li v-for="(q, index) in questions">
                            <div class="collapsible-header" style="position: relative">
                                <span :style="{ 'background-color' : q.color }" class="dot"></span>
                                {{ q.name }}
                                <span class="value" :style="{ 'background-color' : q.color }">
                                    {{ q.value }}
                                </span>

                            </div>
                            <div class="collapsible-body">
                                <span>
                                {{ q.comment }}
                              &nbsp;<a href="#" v-on:click.prevent="clickScore(index)">Edit</a>
                                </span>
                            </div>
                        </li>
                    </ul>
                    <span style="text-align: right">
                        <h3>Total {{ totalScore}}</h3>
                    </span>

                    <div class="right-align">
                        <a @click.prevent="edit"
                           v-bind:class="{'disabled': saving}"
                           v-bind:disabled="saving"
                           class="waves-effect waves-light btn right-align">
                            Edit
                        </a>&nbsp;

                        <a @click.prevent="save"
                           v-bind:class="{'disabled': saving}"
                           v-bind:disabled="saving"
                           class="waves-effect waves-light btn right-align" style="background-color: #c0a375">
                            Save
                        </a>
                    </div>
                </div>

            </div>
            <div class="col s12 m12 l12 xl4 right-bar">
                <last-month-score
                        :view-from="submitFor"
                ></last-month-score>
            </div>
        </div>

    </div>
</template>

<script>
  import LastMonthScore from './partials/LastMonthScore'
  import axios from 'axios'

  export default {
    name: 'StressScore',
    components: {
      LastMonthScore
    },

    props: {
      mode: String,
      submitFor: String,
      actionUrl: String,
      successUrl: String,
      lastMonthUrl: String
    },

    computed: {
        totalScore () {
          return parseInt(this.questions[0].value) + parseInt(this.questions[1].value) +
            parseInt(this.questions[2].value) + parseInt(this.questions[3].value) + parseInt(this.questions[4].value)
        }
    },

    data()  {
      return {
        month: null,
        is_preview: false,
        saving: false,
        form_saved: false,
        current_question_index: 0,
        questions: [
          {
            color: window.AppInfo.stress_score_colors[0],
            name: 'Sales Score',
            score_type: 1,
            value: 10,
            comment: null
          },
          {
            color: window.AppInfo.stress_score_colors[1],
            name: 'Expenditure Score',
            score_type: 2,
            value: 10,
            comment: null
          },
          {
            color: window.AppInfo.stress_score_colors[2],
            name: 'Cashflow Score',
            score_type: 3,
            value: 10,
            comment: null
          },
          {
            color: window.AppInfo.stress_score_colors[3],
            name: 'Manpower Score',
            score_type: 4,
            value: 10,
            comment: null
          },
          {
            color: window.AppInfo.stress_score_colors[4],
            name: 'Personal Score',
            score_type: 5,
            value: 10,
            comment: null
          },
        ]
      }
    },

    mounted() {
      this.window = window;
      this.month = new Date(this.submitFor).toLocaleString('en-us', { month: 'long' });
      this.window.onbeforeunload = (e) => {
         if (!this.form_saved) {
           let message = "You have not saved your changes.", e = e || window.event;
           if (e) {
             e.returnValue = message;
           }
           return message;
         }
      };

    },

    methods: {

      decrement_question () {
        if(this.current_question_index > 0) {
          this.current_question_index--;
        }
      },

      increment_question () {
        if(this.current_question_index !== (this.questions.length - 1)) {
          this.current_question_index++;
        }
      },

      preview() {
        this.is_preview = true;
        $(document).ready(function() {
          $('.collapsible').collapsible();
        });
      },

      edit () {
        this.current_question_index = 0;
        this.is_preview = false;
      },

      clickScore (index) {
        this.current_question_index = index;
        this.is_preview = false;
      },

      save () {
        this.form_saved = true;
        this.saving = !this.saving;
        M.toast({html: 'Saving...', classes: 'saving_toast'});
        let savingToastInstance = M.Toast.getInstance(document.querySelector('.saving_toast'));

        axios.post(this.actionUrl,
            {
              'sales_score' : this.questions[0].value,
              'expenditure_score' : this.questions[1].value,
              'cashflow_score' : this.questions[2].value,
              'manpower_score' : this.questions[3].value,
              'personal_score' : this.questions[4].value,
              'score_date'     : this.submitFor,
              'data'           : this.questions
            }).then(response => {

                savingToastInstance.dismiss();
                this.saving = !this.saving;

                if(response.data.success) {
                  M.toast({html:  response.data.messages, classes: 'toast-background-color'});
                  window.location.href = this.successUrl;
                } else {
                  M.toast({html: 'Error, ' + response.data.messages, classes: 'red accent-2'});
                }

            }).catch(err => {
                savingToastInstance.dismiss();
                this.saving = !this.saving;
                M.toast({html: 'Error, try again later', classes: 'red accent-2'});
            });
      }


    }
  }
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/scores/StressScoreForm.vue